/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    firstName?: string;

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    lastName?: string;

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    fiscalCode?: string;

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    email?: string | null;

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof UpdateUserDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof UpdateUserDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof UpdateUserDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateUserDto
     */
    client?: JoinEntityDto;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof UpdateUserDto
     */
    authorities?: Array<JoinEntityDto>;

    /**
     * @type {string}
     * @memberof UpdateUserDto
     */
    note?: string | null;
}
